var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{class:{'page-header-fab-padding': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"tag":"h1","id":"title-bar","xs12":""}},[_vm._v("\n    Timeline\n  ")]),_c('Timeline',{attrs:{"timeline-days":_vm.timelineDays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }